import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";

export async function ToggleVisibilityMarcaProductoAction(
  idMarca: string
): Promise<ApiResponse<MarcaProductoInterface>> {
  const { data } = await apiClient.patch<MarcaProductoInterface>(
    `gpMarcaProductos/${idMarca}/toggleVisibility`
  );
  return {
    status: 200,
    data,
    message:
      "Visibilidad de la Marca de producto actualizada correctamente",
  };
}
